import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  FormHelperText,
  InputAdornment, IconButton, Icon
} from "@material-ui/core";
import {Field} from 'formik';
import {KeyboardDatePicker} from "@material-ui/pickers";
import Autocomplete from '@material-ui/lab/Autocomplete';

export const TextInput = ({name, sm=12, label, type, placeholder='', ...O})=>{
  const [input, setInput] = React.useState({
    showPassword: false
  });
  const InputLabelProps={};
  const InputProps={};
  if(['date','time'].includes(type) || placeholder !== ''){
    InputLabelProps.shrink = true;
  }
  if(type==='password'){
    InputProps.endAdornment = <>
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={event => { setInput({...input, showPassword: !input.showPassword}) }}
          onMouseDown={(event => event.preventDefault())}
        >
          <Icon className={'mdi '+ (input.showPassword ? 'mdi-eye-outline': 'mdi-eye-off-outline')} />
        </IconButton>
      </InputAdornment>
    </>;
  }
  if(O.startIcon){
    InputProps.startAdornment = <InputAdornment position="start">
      <IconButton aria-label={`${name}_input-icon`}>
        <Icon className={O.startIcon} />
      </IconButton>
    </InputAdornment>
  }
  return <Grid item xs={12} sm={sm}>
    <Field name={name}>
      {({field,form,meta}) => <TextField
        type={type==='password' ? (input.showPassword?'text':'password') : type}
        error={meta.touched && Boolean(meta.error)}
        helperText={meta.touched && meta.error ? meta.error : ''}
        {...field} {...{placeholder, label, InputLabelProps, InputProps}} fullWidth/>}
    </Field>
  </Grid>
};

export const RadioInput = ({name, sm=12, label, options}) => {
  return <Grid item xs={12} sm={sm} style={{paddingBottom: 0}}>
    <Field name={name}>
      {({field,form,meta}) => <FormControl fullWidth margin="none" error={meta.touched && Boolean(meta.error)}>
        <FormLabel>{label}</FormLabel>
        <RadioGroup aria-label={name} {...field} row>
          {
            options.map((option, index) => <FormControlLabel key={index} value={option} control={<Radio/>} label={option} />)
          }
        </RadioGroup>
        {meta.touched && meta.error && <FormHelperText error>{meta.error}</FormHelperText>}
      </FormControl>}
    </Field>
  </Grid>
};

export const DateInput = ({name, sm=12, label})=>{
  return <Grid item sm={sm} style={{paddingBottom: 0}}>
    <Field name={name}>
      {({field,form}) => <KeyboardDatePicker
        {...field}
        onChange={(value)=>form.setFieldValue('dob',value)}
        fullWidth
        variant="inline"
        format="DD/MM/YYYY"
        id={name}
        label={label}
        KeyboardButtonProps={{'aria-label': 'change date'}}
      />}
    </Field>
  </Grid>
};

export const DateTimeInput = ({name, sm=12, label})=>{
  return <Grid item xs={12} sm={sm} style={{paddingBottom: 0}}>
    <Field name={name}>
      {({field,form,meta}) => <TextField
        error={meta.touched && Boolean(meta.error)}
        helperText={meta.touched && meta.error ? meta.error : ''}
        {...field}
        fullWidth
        label={label}
        type="datetime-local"
        InputLabelProps={{
          shrink: true,
        }}
      />}
    </Field>
  </Grid>
};

export const AutocompleteInput = ({name, sm=12, label, options})=>{
  return <Grid item xs={12} sm={sm}>
    <Field name={name}>
      {({field, form, meta}) =>
        <FormControl fullWidth margin="none">
          <Autocomplete
            {...field}
            onChange={(e, val)=>form.setFieldValue(name,val)}
            id={name}
            options={options}
            getOptionLabel={option => option}
            renderInput={params => <TextField {...params} label={label} error={meta.touched && Boolean(meta.error)} fullWidth/>}
          />
          {meta.touched && meta.error && <FormHelperText error>{meta.error}</FormHelperText>}
        </FormControl>
      }
    </Field>
  </Grid>
};

const RenderInputs = ({inputs}) => <>
  {
    inputs.map((input, i)=><React.Fragment key={i}>
      {['text','date','time','password'].includes(input.type) && <TextInput {...input} />}
      {input.type === 'radio' && <RadioInput {...input} />}
      {input.type === 'autocomplete' && <AutocompleteInput {...input} />}
    </React.Fragment>)
  }
</>;
export default RenderInputs;
